export class ComboPopulation {
  id: number;
  name: string;
  value: string;
  checked: boolean = false;
  isUserMapped: number = 0;
  wfEnabled: boolean = false;
  checkBoxDisable: boolean = false;
  title: string = '';
  auditFirmId: string;
  defaultRatingId: string;
  isReadOnly: string;
  clientId: any;
  siteid: any;
  clientName: any;
  siteName: any;
}

export class ComboPopulation2 {
  userInfoId: number;
  userName: string;
  value: string;
  checked: boolean = false;
  isUserMapped: number = 0;
  wfEnabled: boolean = false;
  checkBoxDisable: boolean = false;
  title: string = '';
  auditFirmId: string;
  defaultRatingId: string;
  isReadOnly: string;
}
